<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <BlockSymbol
      v-if="vars.blockPositionText"
      :position-text="String(vars?.blockPositionText || '')"
      :block-color="String(vars?.blockColor || '')"
      :block-symbol="String(vars?.blockSymbolText || '')"
      :block-opacity="Number(vars?.blockOpacityNumber || 1)"
      :image-class="`tw-max-w-full lg:tw-max-w-[45%]`"
      :block-logo-image="String(vars?.blockLogoImage)"
      :company-key="company?.company_key"
    />
    <div class="container">
      <div class="row justify-between items-center">
        <div class="col-auto">
          <div
            v-html="vars.titleHtml"
            class="text-62 md:text-38 uppercase fw-500"
            :style="{ color: `var(--c-${vars.textColor})` }"
          ></div>
        </div>

        <div class="col-xl-6 md:d-none"></div>
      </div>

      <div
        class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider"
        data-anim="slide-left delay-1"
        data-gap="30"
        data-slider-cols="xl-3 lg-3 md-2 sm-2 base-1"
      >
        <div class="swiper-wrapper">
          <div v-for="(card, index) in cards" :key="index" class="swiper-slide">
            <div class="imageCard -type-2">
              <div class="imageCard__image relative">
                <library-image v-if="card.photo" :src="String(card.photo)" :alt="String(card.title)" />
                <library-iframe v-else-if="card.video" :src="String(card.video)" />
              </div>

              <h3 class="imageCard__title text-dark-1" :style="{ color: `var(--c-${vars.textColor})` }">
                <span class="text-accent-1">0{{ index + 1 }}</span> {{ card.title }}
              </h3>
              <p class="imageCard__text text-dark-1 tw-mt-4" :style="{ color: `var(--c-${vars.textColor})` }">
                {{ card.description }}
              </p>
            </div>
          </div>
        </div>

        <div class="d-flex mt-60 md:mt-30 lg:tw-mt-20">
          <button class="sliderNav -prev js-prev">
            <i class="icon-left-arrow"></i>
          </button>
          <button class="sliderNav -next ml-20 js-next">
            <i class="icon-right-arrow"></i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import{mapState}from'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'ProcessSlider',

  mixins: [ComponentMixin],

  components: {
    BlockSymbol,
  },

  data() {
    return {
      variants: {
        v1: 'v1',
      },
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['company']),
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>
